import { Grid, TextField, Button, Alert } from "@mui/material";
import { IAttribute } from "../../../../../../../../App/Typings/AbacAttribute";
import useAbacAttributeDetailsState from "../State/AttributeDetailsState";
import SortableTable from "../../../../../../../../App/Components/Table/SortableTable";
import AttributeFeatureTableCell from "./AttributeFeatureTableCell";

interface IAttributeDetailsProps {
  attribute: IAttribute;
}

export function AttributeDetailsForm({ attribute }: IAttributeDetailsProps) {
  const {
    getters: {
      isActive,
      formik,
      columns,
      featureAttributes,
      featureAttributesLoading,
    },
    setters: { setIsActive },
  } = useAbacAttributeDetailsState(attribute);

  return (
    <form onSubmit={formik.handleSubmit}>
      {!isActive && (
        <Alert sx={{ mb: { xs: "8%", sm: "1%" } }} severity="error">
          This Attribute is currently deactivated. Any users that have been
          assigned this Attribute will no longer be able to access Features that
          this Attribute is required for.
        </Alert>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            sx={{ mt: "2%" }}
            name="attributeName"
            label="Attribute Name"
            placeholder="Enter Attribute Name"
            value={formik.values.attributeName}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.attributeName)}
            helperText={
              formik.errors.attributeName ||
              `${formik.values.attributeName.trim().length}/100`
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            minRows={5}
            name="attributeDescription"
            label="Description"
            placeholder="Enter Description"
            onChange={formik.handleChange}
            value={formik.values.attributeDescription}
            error={Boolean(formik.errors.attributeDescription)}
            helperText={
              formik.errors.attributeDescription ||
              `${formik.values.attributeDescription.trim().length}/500`
            }
          />
        </Grid>
        {featureAttributes.length > 0 && (
          <Grid item xs={12} sx={{ mt: "2%", mb: "2%" }}>
            <SortableTable
              columns={columns}
              tableData={featureAttributes}
              rowComponent={AttributeFeatureTableCell}
              loading={featureAttributesLoading}
              hideSearch={true}
              defaultSortIndex={0}
              setTableData={undefined}
              reverse={false}
              customProps={undefined}
            />
          </Grid>
        )}
        <Grid container item xs={6}>
          <Button
            color={isActive ? "secondary" : "primary"}
            sx={{ width: { xs: "100%", sm: "50%" } }}
            variant="contained"
            onClick={() => setIsActive(!isActive)}
          >
            {isActive ? "Deactivate Attribute" : "Activate Attribute"}
          </Button>
        </Grid>
        <Grid container item justifyContent="flex-end" xs={6}>
          <Button
            sx={{ width: { xs: "100%", sm: "30%" } }}
            variant="contained"
            type="submit"
            disabled={!formik.isValid}
          >
            Save Changes
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
